import { selectCarState,selectCarLocationList } from "../../api/config/modules/VehicleDistribution";

const state = {
    selectCarState: {},
    selectCarLocationList: {}
};

const mutations = {
  SET_SELECTCARSTATE: (state, selectCarState) => {
    state.selectCarState = selectCarState;
  },
  SET_SELECTCARLOCATIONLIST: (state, selectCarLocationList) => {
    state.selectCarLocationList = selectCarLocationList;
  },
};

const actions = {
  GET_SELECTCARSTATE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        selectCarState(data).then((res) => {
          commit("SET_SELECTCARSTATE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTCARLOCATIONLIST: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        selectCarLocationList(data).then((res) => {
          commit("SET_SELECTCARLOCATIONLIST", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
